module.exports = __webpack_public_path__ + "static/media/not-found-mobile-background.2062a55f.svg";